import { CertificadoAttributes } from "@fl/shared/src/types/models/suporte_fl/certificados";
import { ITableDataColumns } from "@fl/shared/src/types/tables";
import moment from "moment";
import React from "react";
import { Button, Modal } from "react-bootstrap";
import { BsCircleFill } from "react-icons/bs";
import { ICertDataModal } from "../../../../pages/private/condominios/certificados";
import StringsFuncs from "../../../../utils/stringsFuncs";
import TableData from "../../../tables";

interface IProps {
  showModal: boolean;
  setShowModalListCerts: React.Dispatch<React.SetStateAction<boolean>>;
  data: ICertDataModal | null;
}

const ListCertificadoModal: React.FC<IProps> = ({
  showModal,
  setShowModalListCerts,
  data,
}) => {
  const columnsTable: ITableDataColumns[] = [
    {
      columnKey: "id_certificado",
      label: "#ID",
      pk: true,
      alignText: "text-center",
    },
    {
      columnKey: "arquivo",
      label: "Nome do Arquivo",
      alignText: "text-center",
    },
    {
      columnKey: "status",
      label: "Situação",
      alignText: "text-center",
      render: (i: CertificadoAttributes) => {
        if (moment(i.data_expiracao).isAfter(moment())) {
          return <BsCircleFill size={13} color="green" title="Válido" />;
        } else {
          return <BsCircleFill size={13} color="red" title="Vencido" />;
        }
      },
      sortValue: (item: CertificadoAttributes) => item.data_emissao,
    },
    {
      columnKey: "data_emissao",
      label: "Data de Emissão",
      alignText: "text-center",
      render: (i: CertificadoAttributes) => {
        return moment(i.data_emissao).format("DD/MM/YYYY HH:mm");
      },
    },
    {
      columnKey: "data_expiracao",
      label: "Data de Expiração",
      alignText: "text-center",
      render: (i: CertificadoAttributes) => {
        return moment(i.data_expiracao).format("DD/MM/YYYY HH:mm");
      },
    },
    {
      columnKey: "createdAt",
      label: "Data de Criação",
      alignText: "text-center",
      render: (i: CertificadoAttributes) => {
        return moment(i.createdAt).format("DD/MM/YYYY HH:mm");
      },
    },
  ];

  return (
    <Modal
      show={showModal}
      onHide={() => setShowModalListCerts(false)}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          {!data
            ? ""
            : `Listagem de Certificados - ${new StringsFuncs(data.condominio).cammelCase()}`}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="container-text text-jsutify">
        <TableData
          columns={columnsTable}
          data={data ? data.certificates : []}
        />
        <span>
          <small>Listagem: {data?.certificates.length}</small>
        </span>
      </Modal.Body>
      <Modal.Footer>
        <div style={{ width: "100%" }} className="d-flex justify-content-end">
          <Button
            variant="danger"
            type="submit"
            onClick={() => setShowModalListCerts(false)}
          >
            Fechar
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default ListCertificadoModal;
